var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:view-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z",
    fill: "#FD6202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4035 8.80875C16.7419 7.09743 15.5934 5.61747 14.0998 4.5518C12.6063 3.48612 10.8332 2.88145 8.99976 2.8125C7.1663 2.88145 5.39323 3.48612 3.89969 4.5518C2.40614 5.61747 1.2576 7.09743 0.596011 8.80875C0.55133 8.93234 0.55133 9.06766 0.596011 9.19125C1.2576 10.9026 2.40614 12.3825 3.89969 13.4482C5.39323 14.5139 7.1663 15.1186 8.99976 15.1875C10.8332 15.1186 12.6063 14.5139 14.0998 13.4482C15.5934 12.3825 16.7419 10.9026 17.4035 9.19125C17.4482 9.06766 17.4482 8.93234 17.4035 8.80875ZM8.99976 12.6562C8.27662 12.6562 7.56973 12.4418 6.96846 12.0401C6.36719 11.6383 5.89856 11.0673 5.62183 10.3992C5.34509 9.73109 5.27269 8.99594 5.41377 8.2867C5.55484 7.57746 5.90307 6.92598 6.4144 6.41464C6.92574 5.90331 7.57722 5.55508 8.28646 5.414C8.99571 5.27293 9.73086 5.34533 10.3989 5.62207C11.067 5.8988 11.6381 6.36743 12.0398 6.9687C12.4416 7.56996 12.656 8.27686 12.656 9C12.6545 9.96924 12.2688 10.8984 11.5835 11.5837C10.8981 12.2691 9.969 12.6548 8.99976 12.6562Z",
    fill: "#FD6202"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEyeIcon);
export default __webpack_public_path__ + "static/media/viewEyeIcon.fec46cfe982b4ec96da01d60c851c867.svg";
export { ForwardRef as ReactComponent };